"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BurgerMenuContent = require("./BurgerMenuContent");
Object.keys(_BurgerMenuContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BurgerMenuContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BurgerMenuContent[key];
    }
  });
});
var _LazyBurgerMenuContent = require("./LazyBurgerMenuContent");
Object.keys(_LazyBurgerMenuContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LazyBurgerMenuContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LazyBurgerMenuContent[key];
    }
  });
});
